import { applicationPricingStatusApi } from 'app/services/api';

import { FeatureFlag } from 'constants/featureFlags';
import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectFeatureFlagByKey } from 'store/global/selectors';

export const PRICING_STATUS_ACTION_TYPE = createNamedActions(
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/pricingStatus`,
  {
    UPDATE_PRICING_STATUS: 'UPDATE_PRICING_STATUS',
    RESET_PRICING_STATUS: 'RESET_PRICING_STATUS',
  },
);

export const updatePricingStatusAction = catchAsyncActionError(
  ({ include, ...params }) =>
    async (dispatch, getState) => {
      const state = getState();
      const isLoadPricingStatusConfigurationsByIncludesEnabled = selectFeatureFlagByKey(
        FeatureFlag.EnableLoadPricingStatusConfigurationsByIncludes,
      )(state);

      const options = isLoadPricingStatusConfigurationsByIncludesEnabled ? { include } : {};
      const { data } = await applicationPricingStatusApi.updatePricingStatus(params, options);

      return dispatch({
        type: PRICING_STATUS_ACTION_TYPE.UPDATE_PRICING_STATUS,
        payload: data,
      });
    },
);

export const setPricingStatusAction = data => ({
  type: PRICING_STATUS_ACTION_TYPE.UPDATE_PRICING_STATUS,
  payload: data,
});
